export const secondaryVariantStyle = 'secondary';

export const formGroupVariants = {
    time: 'time',
    date: 'date',
    plain: 'plain',
    buttonRadioGroup: 'buttonRadioGroup',
    radioButtonGroup: 'radioButtonGroup',
    multiSelect: 'multiSelect',
    select: 'select',
    text: 'text',
    textarea: 'textarea',
    postcodeSearchableList: 'postcodeSearchableList',
    checkbox: 'checkbox',
    currency: 'currency',
    list: 'list',
    attachment: 'attachment',
    number: 'number',
    amount: 'amount',
    range: 'range',
    searchableList: 'searchableList',
    editor: 'editor',
    asyncSearchableList:'asyncSearchableList',
    file: 'file',
};

export const inputType = {
    upload: 'upload',
    multiUpload: 'multi upload',
    calendar: 'calendar',
    dropDown: 'drop down',
    textArea: 'text area',
    amount: 'amount',
    text: 'text',
    table: 'table',
    noInput: 'no input',
};